
  import { Vue, Component, Prop } from "vue-property-decorator";

  import SearchableDocumentsList from "@/components/documents/SearchableDocumentsListNew.vue";
  import UploadDocument from "@/components/documents/UploadDocumentNew.vue";
  import { User } from "@/generated/graphql";

  @Component({
    components: {
      SearchableDocumentsList,
      UploadDocument,
    },
  })
  export default class ResumeSidebar extends Vue {
    @Prop({ type: String, required: true }) readonly contractorUserId!: string;
    @Prop({ type: String, required: true }) readonly managerUserId!: string;
    @Prop({ type: String, required: true }) readonly contractorFullName!: string;
    @Prop({ type: String, required: true }) readonly companyId!: string;
    @Prop({ type: Object, required: true }) readonly currentUser!: User;

    get query(): Object {
      return {
        _and: [
          {
            uploaded_by: {
              _eq: this.currentUser.id,
            },
          },
          {
            attached_to: {
              user_id: {
                _eq: this.contractorUserId,
              },
            },
          },
        ],
      };
    }
  }
